import { useForm } from '@american-autonomy/ag-ui';

import { RESET_OPTIONS } from './constants';
import type { Props, ServiceIntervalsFormSchema, UseData } from './types';

const useData = ({ isEditable, isSaving, onSubmit, partsByAssetModelId }: Props): UseData => {
    const values = Object.values(partsByAssetModelId)
        .flat()
        .reduce<ServiceIntervalsFormSchema>(
            (seeded, part) => ({
                intervals: {
                    ...seeded.intervals,
                    [part.assetModelPartId]: part.effectiveIntervalValue
                },
                units: { ...seeded.units, [part.assetModelPartId]: part.effectiveIntervalUnit }
            }),
            { intervals: {}, units: {} }
        );

    const form = useForm<ServiceIntervalsFormSchema>({
        mode: 'onChange',
        resetOptions: RESET_OPTIONS,
        values
    });

    const {
        formState: { errors },
        handleSubmit
    } = form;

    const hasErrors = Object.keys(errors).length > 0;

    return {
        form,
        hasErrors,
        isSaveDisabled: isSaving || !isEditable || hasErrors,
        onSave: handleSubmit(onSubmit)
    };
};

export default useData;
